var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{attrs:{"id":"loader"}},[_c('div',{staticClass:"load-close-btn",on:{"click":_vm.off}},[_c('i',{staticClass:"fa fa-times"})]),_vm._v(" "),_c('div',{staticClass:"flex-spinner"},[_c('div',[_c(_vm.spinner,{tag:"component",attrs:{"animation-duration":1000,"size":120,"color":'#fff'}})],1)]),_vm._v(" "),_c('h4',{staticClass:"load-text"},[_vm._v(_vm._s(_vm.title)+"…")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b75faae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/Loading.vue
// module id = 2303
// module chunks = 1